import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissoesAcessoService } from '../permissoes-acesso.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { GrupoAcesso } from '../../comum/modelos/grupo-acesso';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { GrupoAcessoPermissaoFuncionalidade } from '../../comum/modelos/grupo-acesso-permissao-funcionalidade';
import { Funcionalidade } from '../../comum/modelos/funcionalidade';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-cadastro-grupo-acesso',
  templateUrl: './cadastro-grupo-acesso.component.html',
  styleUrls: ['./cadastro-grupo-acesso.component.css']
})
export class CadastroGrupoAcessoComponent implements OnInit {

  permissoesAcesso: GrupoAcessoPermissaoFuncionalidade[];
  funcionalidades: Funcionalidade[];
  grupoAcesso: GrupoAcesso;

  MODO: string;
  CADASTRAR = 'Cadastrar';
  ATUALIZAR = 'Atualizar';
  statusCode: number;
  selecionados: boolean;

  public evento: Evento;
  public paginacao: Paginacao;

  public loading = false;

  constructor(
    private _permissoesAcessoService: PermissoesAcessoService,
    private _comumService: ComumService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    private _cookieService: CookieService,
    public _authService: AuthService) {
    this.permissoesAcesso = new Array<GrupoAcessoPermissaoFuncionalidade>();
    this.funcionalidades = new Array<Funcionalidade>();
    this.grupoAcesso = new GrupoAcesso();
    this.evento = this._comumService.evento;
    this.paginacao = new Paginacao();
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    const id = this._activatedRoute.snapshot.params['id'];
    const self = this;

    if (id !== undefined) {
      forkJoin(
        this._permissoesAcessoService.obterFuncionalidadesHttp(),
        this._permissoesAcessoService.obterGrupoAcessoHttp(id),
        this._permissoesAcessoService.obterGruposAcessoPermissaoFuncionalidadeHttp(id))
        .subscribe(([funcionalidades, grupoAcesso, gruposAcessoPermissaoFuncionalidade]) => {
          this.grupoAcesso = grupoAcesso;
          for (const funcionalidade of funcionalidades) {
            const novoGrupoAcessoPermissaoFuncionalidade = new GrupoAcessoPermissaoFuncionalidade();
            novoGrupoAcessoPermissaoFuncionalidade.funcionalidade = funcionalidade;
            novoGrupoAcessoPermissaoFuncionalidade.idGrupoAcesso = grupoAcesso.idGrupoAcesso;
            for (const grupoAcessoPermissao of gruposAcessoPermissaoFuncionalidade) {
              if (grupoAcessoPermissao.funcionalidade.idFuncionalidade === funcionalidade.idFuncionalidade) {
                novoGrupoAcessoPermissaoFuncionalidade.idGrupoAcessoPermissaoFuncionalidade
                  = grupoAcessoPermissao.idGrupoAcessoPermissaoFuncionalidade;
                novoGrupoAcessoPermissaoFuncionalidade.visualizar = grupoAcessoPermissao.visualizar;
                novoGrupoAcessoPermissaoFuncionalidade.alterar = grupoAcessoPermissao.alterar;
                break;
              }
            }
            self.permissoesAcesso.push(novoGrupoAcessoPermissaoFuncionalidade);
          }
          self.loading = false;
          this.grupoAcesso = grupoAcesso;
          this.MODO = this.ATUALIZAR;
        });
    } else {
      this._permissoesAcessoService.obterFuncionalidadesHttp()
        .subscribe((funcionalidades: Funcionalidade[]) => {
          funcionalidades.forEach(funcionalidade => {
            const grupoAcessoPermissao = new GrupoAcessoPermissaoFuncionalidade();
            grupoAcessoPermissao.funcionalidade = funcionalidade;
            self.permissoesAcesso.push(grupoAcessoPermissao);
          });
          this.grupoAcesso.idCliente = parseInt(this._cookieService.get('idCliente'), 10);
          this.MODO = this.CADASTRAR;
          this.loading = false;
        });
    }
  }

  onSubmit(): void {
    this.loading = true;
    const self = this;

    if (this.MODO === this.CADASTRAR) {
      this._permissoesAcessoService.cadastrarGrupoAcessoHttp(this.grupoAcesso)
        .subscribe(response => {
          this.cadastrarPermissoesAcesso(response.body.idGrupoAcesso);
          this.loading = false;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['permissoes']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    } else {
      this._permissoesAcessoService.atualizarGrupoAcessoHttp(this.grupoAcesso)
        .subscribe(response => {
          this.cadastrarPermissoesAcesso(this.grupoAcesso.idGrupoAcesso);
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.atualizar = true;
          this.router.navigate(['permissoes']);
          console.log(response.status);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
  }

  cadastrarPermissoesAcesso(idGrupoAcesso: number): void {
    const gruposAcessoPermissaoInsert = new Array<GrupoAcessoPermissaoFuncionalidade>();
    const grupoAcessoPermissaoUpdate = new Array<GrupoAcessoPermissaoFuncionalidade>();
    this.permissoesAcesso.forEach(grupoAcessoPermissao => {
      if (grupoAcessoPermissao.idGrupoAcessoPermissaoFuncionalidade !== null
        && grupoAcessoPermissao.idGrupoAcessoPermissaoFuncionalidade !== undefined) {
        grupoAcessoPermissaoUpdate.push(grupoAcessoPermissao);
      } else {
        gruposAcessoPermissaoInsert.push(grupoAcessoPermissao);
      }
    });
    if (grupoAcessoPermissaoUpdate.length > 0) {
      this._permissoesAcessoService.atualizarGruposAcessoPermissaoFuncionalidadeHttp(grupoAcessoPermissaoUpdate)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['permissoes']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    if (gruposAcessoPermissaoInsert.length > 0) {
      this._permissoesAcessoService.cadastrarGruposAcessoPermissaoFuncionalidadeHttp(gruposAcessoPermissaoInsert)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['permissoes']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/permissoes-acesso/cadastro-grupo-acesso/cadastro-grupo-acesso.component.ts